module.exports = __webpack_public_path__ + "img/logo-unionyamistad.a9028099.png";